module.exports = __webpack_public_path__ + "sq9-8eab47a6.png";